import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Dropdown, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEllipsisV, faEye, faTimes } from "@fortawesome/free-solid-svg-icons";

import { DashboardLayout } from "../../../Layout/DashboardLayout";
import CustomTable from "./../../../Components/CustomTable";
import { questionModal, successModal } from "../../../Components/CustomModal";
import CustomFilters from "../../../Components/CustomFilters";
import BASEURL from "../../../Config/global";
import CustomPagination from "../../../Components/CustomPagination";
import CustomLoader from "../../../Components/CustomLoader";
import { deleteRequest, patchRequest } from "../../../Util/requests";

// drag/drop
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { listSorted } from "../../../Services/Sorting";

const DashboardLinkManagement = () => {
    const [data, setData] = useState([]);
    const [entries, setEntries] = useState(10);
    const [offset, setOffset] = useState(0);
    const [filterSearchValue, setFilterSearchValue] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    const [loader, setLoader] = useState(false);
    const [isListPositionUpdated, setIsListPositionUpdated] = useState(false);

    useEffect(() => {
        document.title = "Relax Scofa | Product  Link Management";
    }, []);

    useEffect(() => {
        fetchData();
    }, [entries, offset]);
    useEffect(() => {
        if (filterSearchValue === "") return;
        const timeoutId = setTimeout(() => { fetchData(); }, 1500);
        return () => clearTimeout(timeoutId);
    }, [filterSearchValue]);

    const onSortEnd = (result) => {
        if (!result.destination) return;

        const oldIndex = result.source.index;
        const newIndex = result.destination.index;
        if (oldIndex === newIndex) return;

        const reordered = Array.from(data);
        const [moved] = reordered.splice(oldIndex, 1);
        reordered.splice(newIndex, 0, moved);
        setData(reordered);
        setIsListPositionUpdated(true);
    };

    const updateOrdering = async () => {
        const result = await questionModal.fire({
            title: `Do you want to update the order?`,
            confirmButtonText: "Yes",
        });
        if (result.isConfirmed) {
            setLoader(true);
            try {
                const payload = data.map((item, index) => ({
                    id: item.id,
                    sequence: offset + index + 1,
                }));

                const response = await patchRequest('/api/user/dashboard-links/', payload);

                if (response?.data && !response.data.error) {
                    successModal.fire({ text: 'Order updated successfully' });
                    setIsListPositionUpdated(false);
                    fetchData();
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoader(false);
            }
        }
    };

    const fetchData = async () => {
        setLoader(true);
        try {
            const response = await axios.get(
                `${BASEURL}/api/user/dashboard-links/?limit=${entries}&offset=${offset}&search=${filterSearchValue}`
            );
            if (response.data.error !== true) {
                setData(response.data.data);
                setTotalCount(response.data.count);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
        }
    };



    const deleteDashboardLink = async (id) => {
        try {
            const response = await deleteRequest(`/api/user/dashboard-links/${id}/`);
            if (!response.data.error) {
                setData(data.filter((item) => item.id !== id));
                successModal.fire({
                    text: "Product Link deleted successfully",
                    confirmButtonText: "Continue",
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    const deleteAction = (id, name) => {
        questionModal
            .fire({
                title: `Do you want to delete ${name} Product Link?`,
                confirmButtonText: "Yes",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    deleteDashboardLink(id);
                }
            });
    };

    const tableHeaders = [
        { key: "id", title: "S.No" },
        { key: "image_link", title: "Image" },
        { key: "name", title: "Name" },
        { key: "type", title: "Category" },
        { key: "description", title: "Subtitle" },
        { key: "actions", title: "Actions" },
    ];

    return (
        <>
            {/* <DashboardLayout> */}
            <div className="container-fluid">
                <div className="row mb-3">
                    <div className="col-lg-4 mb-2">
                        <h2 className="mainTitle">Product Links</h2>
                    </div>
                    <div className="col-lg-8 text-end mb-2">
                        {isListPositionUpdated && (
                            <button className="customButton secondaryButton me-2" onClick={updateOrdering}>
                                Update Order
                            </button>
                        )}
                        <Link to="/scofa/product-links/add" className="customButton primaryButton">
                            Add Product  Link
                        </Link>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12">
                        <CustomFilters
                            enteries={entries}
                            totalCount={totalCount}
                            entriesFilter={true}
                            setEnteries={(val) => { setOffset(0); setEntries(val); }}
                            filterSearch={true}
                            filterSearchValue={filterSearchValue}
                            setFilterSearchValue={setFilterSearchValue}
                        />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12">
                        <DragDropContext onDragEnd={onSortEnd}>
                            <Droppable droppableId="dashboard-link-list">
                                {(provided) => (
                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                        <CustomTable headers={tableHeaders}>
                                            <tbody>
                                                {loader && (
                                                    <tr>
                                                        <td colSpan={15}>
                                                            <div className="d-flex align-items-center justify-content-center" style={{ height: 300 }}>
                                                                <Spinner animation="border" role="status">
                                                                    <span className="visually-hidden">Loading...</span>
                                                                </Spinner>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                                {!loader && data && data.map((item, index) => (
                                                    <Draggable key={item.id} draggableId={`link-${item.id}`} index={index}>
                                                        {(provided, snapshot) => (
                                                            <tr
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                className={snapshot.isDragging ? 'dragging' : ''}
                                                            >
                                                                <td>{offset + index + 1}</td>
                                                                <td className="text-capitalize">
                                                                    {item.image_link && (
                                                                        <img
                                                                            src={item.image_link}
                                                                            alt="thumbnail"
                                                                            className="thumbnail me-2"
                                                                            style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "4px" }}
                                                                        />
                                                                    )}
                                                                </td>
                                                                <td>{item.name}</td>
                                                                <td>{item.type_name || item.type}</td>
                                                                <td style={{ maxWidth: '100px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{item.description}</td>
                                                                <td>
                                                                    <Dropdown className="tableDropdown">
                                                                        <Dropdown.Toggle variant="transparent" className="notButton classicToggle">
                                                                            <FontAwesomeIcon icon={faEllipsisV} />
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu align="end" className="tableDropdownMenu">
                                                                            <Link to={`/scofa/product-links/edit/${item.id}`} className="tableAction">
                                                                                <FontAwesomeIcon icon={faEdit} className="tableActionIcon" />
                                                                                Edit
                                                                            </Link>
                                                                            <button className="tableAction" onClick={() => deleteAction(item.id, item.name)}>
                                                                                <FontAwesomeIcon icon={faTimes} className="tableActionIcon" />
                                                                                Delete
                                                                            </button>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </Draggable>
                                                ))}
                                                {provided.placeholder}
                                            </tbody>
                                        </CustomTable>
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12">
                        <CustomPagination
                            enteries={entries}
                            totalCount={totalCount}
                            setCurrentPage={setOffset}
                            currentPage={offset}
                        />
                    </div>
                </div>
            </div>
            {/* </DashboardLayout> */}
            {/* {loader && <CustomLoader />} */}
        </>
    );
};

export default DashboardLinkManagement;
